import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { MastersProvider } from "./context/MastersContext";
import { LayoutProvider } from "./context/LayoutContext";
import { register as registerServiceWorker } from "./serviceWorkerRegistration";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";

// Create a QueryClient instance with optimized settings
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - optimized from 0 for better caching
      gcTime: 30 * 60 * 1000, // 30 minutes (formerly cacheTime)
      refetchOnWindowFocus: false, // Disabled - data changes infrequently
      retry: 2, // Retry failed queries twice
    },
  },
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <MastersProvider>
          <LayoutProvider>
            <App />
          </LayoutProvider>
        </MastersProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// Register service worker for PWA support (production only)
if (import.meta.env.PROD) {
  registerServiceWorker();
}
